<!--
 * @Author: 孙照
 * @LastEditTime: 2023-10-07 18:13:35
 * @Description: 场站选择 select 框
 * @FilePath: \fuzhou\src\module\stationSelect\index.vue
-->
<template>
  <div class="station-select">
    <div class="select-bar" @click="handleExpansion">
      <span class="current-value">{{ handleStation.stationName }}</span>
      <span class="select-arrow">
        <img
          class=arrow-img
          :class="[hasExpansion ? 'rotate-active' : 'rotate-dis']"
          src="@/assets/images/selectArrow.png"
          alt=""
        >
      </span>
    </div>
    <transition name="slide">
      <div class="options" v-show="hasExpansion">
        <div
          class="option-item"
          v-for="item in optionData"
          :key="item.stationId"
          @click="handleSelect(item)"
        >{{ item.stationName }}</div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'stationSelect',
  data() {
    return {
      hasExpansion: false,
      optionData: [],
      handleStation: {}, // 选中的场站信息
    };
  },
  computed: {
    ...mapGetters({
      stationList: 'stationList',
      stationId: 'stationId',
      currentStationId: 'currentStationId',
    }),
    // 当前场站
    currentStation() {
      return this.optionData.find((item) => item.stationId === this.currentStationId);
    },
  },
  watch: {
    stationList: {
      handler(val) {
        this.optionData = val;
      },
      immediate: true,
    },
    currentStation: {
      handler(val) {
        this.handleStation = { ...val };
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations([
      'getStationId',
      'getCurrentStation'
    ]),
    handleExpansion() {
      this.hasExpansion = !this.hasExpansion;
    },
    // 选中并返回场站信息
    handleSelect(item) {
      // console.log('---选中场站', item);
      this.handleStation = { ...item };
      this.getCurrentStation(item.stationId);
      this.hasExpansion = false;
    },
  },
};
</script>

<style lang="less" scoped>
.station-select {
  position: relative;
  .select-bar {
    width: 764px;
    height: 56px;
    position: relative;
    .backgroundImage('@/assets/images/stationSelectBg.png');
    .current-value {
      width: 500px;
      height: 56px;
      text-align: center;
      line-height: 56px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-shadow: 0px 0px 8px #00B2FF;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .select-arrow {
      position: absolute;
      top: 50%;
      right: 28px;
      transform: translateY(-50%);
      .arrow-img {
        width: 25px;
        height: 13px;
      }
      .rotate-active {
        transform: rotate(180deg);
        transition: all .5s;
      }
      .rotate-dis {
        transform: rotate(0);
        transition: all .5s;
      }
    }
  }
  // css代码：
  // 这部分代码单独写就可以
  // 下拉收起的动画效果
  .slide-leave-active,.slide-enter-active {
    transition: height 0.3s ease;
  }
  .slide-enter,.slide-leave-to {
    height:0;
  }
  .slide-enter-to,.slide-leave {
    height: 280px;
  }

  .options {
    z-index: 9;
    width: 754px;
    max-height: 280px;
    position: absolute;
    top: 65px;
    left: 50%;
    will-change: height;
    transform: translateX(-50%);
    background: rgba(143,204,255,0.09) linear-gradient(264deg, rgba(0,92,167,0.43) 0%, rgba(0,92,167,0.85) 51%, rgba(0,92,167,0.43) 100%);
    box-shadow: inset 0px 0px 11px 0px rgba(79,179,255,0.54);
    border: 1px solid;
    border-image: linear-gradient(140deg, rgba(136, 230, 255, 1), rgba(143, 204, 255, 1)) 1 1;
    backdrop-filter: blur(19px);
    overflow: hidden;
    overflow-y: auto;
    /* 滚动条整体 */
    &::-webkit-scrollbar {
        height: 10px;
        width: 2px;
    }
    /* 两个滚动条交接处 -- x轴和y轴 */
    &::-webkit-scrollbar-corner {
        background-color: transparent;
    }

    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(16, 64, 107, 1);
        background: #535353;
    }

    /* 滚动条轨道 */
    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #ededed;
    }
    .option-item {
      width: 100%;
      height: 56px;
      line-height: 56px;
      box-sizing: border-box;
      padding-left: 45px;
      border-radius: 1px;
      border-bottom: 1px solid;
      border-image: linear-gradient(270deg, rgba(168, 225, 255, 0.05), rgba(112, 191, 255, 0.21)) 1 1;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-shadow: 0px 0px 8px #00B2FF;
      &:hover {
        background: rgba(96,178,255,0.15);
      }
    }
  }
}
</style>
